import { Link } from "react-router-dom";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionTitle({ title, subtitle, moreTo, moreLabel = "查看更多", icon }: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-900 md:text-2xl">
          {icon && <i className={`${icon} text-primary-600`}></i>}
          {title}
        </h2>
        {subtitle && <span className="hidden text-sm text-foreground-400 sm:inline">{subtitle}</span>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-500 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}